<template>
  <div class="topic-resume">
    <div class="contentt">
      <div class="header">
        <slot name="header"></slot>
      </div>
      <div class="middle w-100">
        <div class="left">
          <h2 class="cursor-pointer" @click="$emit('click')">
            {{ title }}
          </h2>
          <slot name="description"></slot>
        </div>
        <div class="right cursor-pointer" @click="$emit('click')">
          <img v-if="imageLink" :src="imageLink" alt="" />
        </div>
      </div>
      <div class="bottom cursor-pointer" :class="statusColor" @click="$emit('click')">
        {{ status }}
      </div>
    </div>
    <div class="buttons">
      <slot name="buttons"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'topic-resume',

  props: {
    title: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
    statusColor: {
      type: String,
      required: true,
    },
    imageLink: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped></style>
